/*
 * Project: LegalPlace assistant
 * File: src\redux\reducers\root.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */


// import every single reducer, to manage the context

import { combineReducers } from 'redux';
import { empty, loading } from './global';
import { ccontract } from './contract';
import { outputReducer } from './output';
import errorReducer from './error';
import { optionHoverReducer } from './option_hover';
import flatUIReducer from './flat_ui';
import { account_settings } from './account_settings';
import viewsReducer from './views';
import { appStateReducer } from './app_state';
import { inputContext } from './input_context';
import { togglePreviewReducer, popoverReducer } from './toggle_preview';
import checkoutReducer from './checkout_operations';
import { loadingDetails } from './loading';
import { documentStateReducer } from './document_state';
import { updateOVCReducer } from './load_ovc';
import lpErrorReducer from './lperrors';
import '../actions/load_ovc';


const lpReducer = combineReducers({
  empty,
  loading,
  contract: ccontract,
  output: outputReducer,
  error: errorReducer,
  optionHover: optionHoverReducer,
  flat: flatUIReducer,
  account_settings,
  views: viewsReducer,
  appstate: appStateReducer,
  input_context: inputContext,
  preview: togglePreviewReducer,
  checkout_operations: checkoutReducer,
  popover: popoverReducer,
  loading_details: loadingDetails,
  document_state: documentStateReducer,
  loadedOvc: updateOVCReducer,
  errors: lpErrorReducer,
});

export default lpReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/root.js